import React from "react";
import './RightParagraph.css' 


export default props => (
  <div className="right-paragraph">
    {props.block.text}
  </div>
);
